// Imports
import {
  Base, DataTypes, SubmitTypes, ErrorTypes
} from '@mixins/forms'

// Parts
const { ObjectDataType: dataType } = DataTypes
const { ProfileSubmit: submitType } = SubmitTypes
const { ProblemDetailsError: errorHandling } = ErrorTypes

// Options
const options = {
  name: 'fmo:profile-form',
  dataType,
  submitType,
  errorHandling,
  submitOnChange: false,
  skipValidation: false,
  tracking: {
    view: false,
    validation: false,
    externalValidation: true,
    submit: {},
    error: false
  }
}

// Component
export default {
  name: 'profile-form',
  mixins: [Base(options)],
  methods: {
    async transformData(data) {
      if (Number(data.gender) === 4 && !data.identity) {
        throw new Error('Identity needed')
      }
      if (
        data.isCommunicationInterests
      ) {
        const interests = []
        Object.keys(data).forEach((el) => {
          if (el.includes('interest-')) {
            const value = el.replace('interest-', '')
            interests.push(value)
            delete data[el]
          }
        })
        if (data.isCommunicationInterests) {
          data.communicationInterestPreferences = interests
        }
      }
      if (data.isPhoneNumbers) {
        const phoneNumber0 = {}
        const phoneNumber1 = {}
        const phoneNumber2 = {}

        const phoneNumbers = []
        Object.keys(data).forEach((el) => {
          if (el.endsWith('0') && data[el]) {
            phoneNumber0[el.slice(0, -1)] = data[el]
          }
          if (el.endsWith('1') && data[el]) {
            phoneNumber1[el.slice(0, -1)] = data[el]
          }
          if (el.endsWith('2') && data[el]) {
            phoneNumber2[el.slice(0, -1)] = data[el]
          }
        })
        if (Object.keys(phoneNumber0).length !== 0) {
          phoneNumbers.push({ ...phoneNumber0 })
        }
        if (Object.keys(phoneNumber1).length !== 0) {
          phoneNumbers.push({ ...phoneNumber1 })
        }
        if (Object.keys(phoneNumber2).length !== 0) {
          phoneNumbers.push({ ...phoneNumber2 })
        }
        return { phoneNumbers }
      }
      if (data.isAddresses) {
        const shouldSortByPreferred = data.preferredAddress === '1'
        const address0 = {}
        const address1 = {}
        const addresses = []
        Object.keys(data).forEach((el) => {
          if (el.endsWith('0') && data[el]) {
            address0[el.slice(0, -1)] = data[el]
          }
          if (el.endsWith('1') && data[el]) {
            address1[el.slice(0, -1)] = data[el]
          }
        })
        if (Object.keys(address0).length !== 0) {
          addresses.push({ ...address0 })
        }
        if (Object.keys(address1).length !== 0) {
          addresses.push({ ...address1 })
        }
        if (shouldSortByPreferred) {
          addresses.reverse()
        }
        return { addresses }
      }

      if (data.isWaterPreference) {
        const preference = data.waterPreference
        return {
          otherPreferences: [preference]
        }
      }

      if (data.isTreatPreference) {
        const preference = data.treatPreference
        return {
          otherPreferences: [preference]
        }
      }

      if (data.islocalMOPreferences) {
        const preference = data.hotel
        return {
          otherPreferences: [preference]
        }
      }

      if (data.isActivitiesInterests) {
        const preferences = Object.values(data).filter((item) => item !== 'true')
        return {
          otherPreferences: [...preferences]
        }
      }

      if (data.isLocationInterestPreferences) {
        const preferences = Object.values(data).filter((item) => item !== 'true')
        return {
          otherPreferences: [...preferences]
        }
      }

      const transformedData = this.getOtherPreferences(data)
      return transformedData
    },
    getOtherPreferences(data) {
      if (!data.isOtherPreferences) {
        return data
      }
      const inputs = this.form.find('input')
      const otherPreferences = []
      inputs.each((index, input) => {
        if (input.id) {
          otherPreferences.push({
            id: input.id,
            selected: !!input.checked
          })
        }
      })
      return { otherPreferences }
    }
  }
}
